import ManageAssignmentsPage from "@Alternatives/Assignments/Pages/ManageAssignmentsPage.vue";

export const routes = [
    {
        path: "/assignments/:workspaceId/:tchProjectId",
        component: ManageAssignmentsPage
    },
]
